import { StCryptographyProvider } from "./StCryptographyProvider";
export class StSymmetricCryptographyProvider implements StCryptographyProvider {
  private readonly TRANSFORMATION_PADDING = "AES-CBC";

  async encrypt(data: string, base64Key: string): Promise<string> {
    console.log("data", data, "base64Key", base64Key);
    const key = await this.importKey(base64Key);

    const iv = window.crypto.getRandomValues(new Uint8Array(16));
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(data);

    const encryptedData = await window.crypto.subtle.encrypt(
      {
        name: this.TRANSFORMATION_PADDING,
        iv: iv,
        length: 256,
      },
      key,
      encodedData
    );

    const ivEncoded = this.arrayBufferToBase64(iv);
    const encryptedDataEncoded = this.arrayBufferToBase64(encryptedData);

    const encodedCombinedData = `${ivEncoded}:${encryptedDataEncoded}`;
    const encodedDataBase64 = btoa(encodedCombinedData);
    return encodedDataBase64;
  }

  async decrypt(data: string, base64Key: string): Promise<string> {
    try {
      const decodedData = atob(data);
      const [ivEncoded, encryptedDataEncoded] = decodedData.split(":");
      const iv = this.base64ToArrayBuffer(ivEncoded);
      const encryptedData = this.base64ToArrayBuffer(encryptedDataEncoded);
      const key = await this.importKey(base64Key);

      const decryptedData = await window.crypto.subtle.decrypt(
        {
          name: this.TRANSFORMATION_PADDING,
          iv: iv,
          length: 256,
        },
        key,
        encryptedData
      );

      const decoder = new TextDecoder();
      return decoder.decode(decryptedData);
    } catch (error: any) {
      console.log("error while decrypting:", error.message);
      throw error;
    }
  }

  private async importKey(base64Key: string): Promise<CryptoKey> {
    try {
      const keyBuffer = this.base64ToArrayBuffer(base64Key);

      console.log("keyBuffer.byteLength", keyBuffer);

      return await window.crypto.subtle.importKey(
        "raw",
        keyBuffer,
        { name: this.TRANSFORMATION_PADDING, length: 256 },
        false,
        ["encrypt", "decrypt"]
      );
    } catch (error: any) {
      console.log("error while importing key:", error.stack);
      throw error;
    }
  }

  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    const byteNumbers = Array.from(bytes);
    return btoa(String.fromCharCode.apply(null, byteNumbers));
  }

  private base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }
}
